import { useContext } from 'react';
import AppInfoContext from 'src/contexts/AppInfo';

const useAppInfo = () => useContext(AppInfoContext);

export default useAppInfo;
